import { render } from "./TaskList2.vue?vue&type=template&id=d6c2f690&scoped=true"
import script from "./TaskList2.vue?vue&type=script&lang=js"
export * from "./TaskList2.vue?vue&type=script&lang=js"

import "./TaskList2.vue?vue&type=style&index=0&id=d6c2f690&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6c2f690"]])

export default __exports__